import React, { Component } from 'react';
import axios from 'axios';
import { Quote, ArrowUpRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '../ui/button';

class HomeRecentPosts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      posts: [],
    };
  }

  componentDidMount() {
    axios.get("https://old.ewenrealtors.com/wp-json/wp/v2/posts?_embed&per_page=6").then(posts => {
      this.setState({
        posts: posts.data
      });
    });
  }

  createMarkup(html) {
    return { __html: html };
  }

  render() {
    return (
      <section className="bg-white py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="h-px w-12 bg-[#8a6b3a]" />
              <span className="text-[#8a6b3a] text-xs uppercase tracking-[0.3em]">Journal</span>
            </div>
            <h2 className="font-serif text-4xl md:text-6xl text-[#0f1a14] leading-[1.05]">Notes from the hills.</h2>
          </div>
          <Link to="/blog" className="inline-flex items-center gap-2 text-[#8a6b3a] hover:text-[#0f1a14] transition-colors text-sm tracking-widest uppercase">
            All Articles <ArrowUpRight className="h-4 w-4" />
          </Link>
        </div>
        <div className="grid md:grid-cols-3 gap-8">
          {this.state.posts.map(post => (
            <Link to={`/blog/${post.slug}`} key={post.id} className="group block">
              <div className="relative aspect-[4/3] overflow-hidden">
                <img alt={post.title.rendered} src={ post._embedded?.['wp:featuredmedia']?.[0]?.source_url || '/fallback-image.jpg'} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" />
              </div>
              <div className="mt-5">
                <div className="text-xs uppercase tracking-widest text-[#8a6b3a]">quick read</div>
                <h3
  className="font-serif text-2xl text-[#0f1a14] mt-3 leading-snug group-hover:text-[#8a6b3a] transition-colors"
  dangerouslySetInnerHTML={{ __html: post.title.rendered }}
/>                
{/* <p className="text-[#0f1a14]/60 mt-3 text-sm leading-relaxed">excerpt</p> */}
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
    );
  }

}

export default HomeRecentPosts;